import {useEffect, useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import { resetPassword } from '../core/_requests'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { validartoken } from './request/request'
import { useLocation } from 'react-router-dom'

const initialValues = {
  token:'',
  password:'',
}

const forgotPasswordSchema = Yup.object().shape({
  password: Yup.string()
  .min(8, 'Minimum 8 symbols')
  .max(50, 'Maximum 50 symbols')
})

type status={
  status:any
}

export function RecoveryPassword() {

  
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)

  
  const [response,setResponse]=useState<status>({ status: '' })
  const [errores,setError]=useState<any>()
  const location = useLocation();
  const [tokenvalido,settokenvalido]=useState<any>()

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tokenParam = searchParams.get('token');
    
    if (tokenParam && tokenParam.trim() !== '') {
      const body={
        token:tokenParam
      }
      settokenvalido(tokenParam)
      validartoken(body).then(response=>{
        if(response.data.error){
          setError(response.data.error)
        }
        else{
        setResponse(response.data)}
    })
      
    } else {
      console.log('Token no válido');
      // Puedes redirigir a otra página o mostrar un mensaje de error.
    }
  }, [location.search]);

////////////////////Nuevo////////////////////////

const [UpdatePassword,setUpdatePassword]= useState("")
const [confirmpassword, setConfirmPassword] = useState('')

function setPassword(event:any){
  setConfirmPassword(event.target.value);
}

//////////////////////////////////////////////////
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setHasErrors(undefined)
      setTimeout(() => {
        resetPassword(tokenvalido,confirmpassword)
          .then(({data: {result}}) => {
            setHasErrors(false)
            setLoading(false)
          })
          .catch(() => {
            setHasErrors(true)
            setLoading(false)
            setSubmitting(false)
            setStatus('The Reset Password detail is incorrect')
          })
      }, 1000)
    },
  })

  


  

  return (
    <>

   <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_password_reset_form'
      onSubmit={formik.handleSubmit}
      
    >
      <div className='text-center mt-n10 '>
      <img alt='Logo' src={toAbsoluteUrl('/media/imgv2/logo_blanco.png')} className='h-100px mx-auto ' />
      </div>
      <br />
      <br />
      <br />

      <div className='text-center mb-10'>
        {/* begin::Title */}
        <h1 className='f-titulo fs-gd text-pink'>Recovery Password</h1>
        {/* end::Title */}

        {/* begin::Link */}
        <div className='text-gray-500  f-parrafo fw-semibold fs-6'>
         The password must contain at least 8 characters.
        </div>
        {/* end::Link */}
      </div>

      {/* begin::Title */}
      {hasErrors === true && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text f-parrafo'>
            Sorry, looks like there are some errors detected, please try again.
          </div>
        </div>
      )}

      {hasErrors === false && (
        <div className='mb-10 bg-light-marino p-8 rounded'   style={{ width: '100%', maxWidth: '300px' ,margin:'auto'}} >
          <div className='text-marino f-parrafo'>Your password has been updated. Please log in to the <Link to='/auth/login' className='text-pink'>CTX Dashboard.</Link></div>
        </div>
      )}
      {/* end::Title */}

      {/* begin::Form group */}
      <div className='fv-row mb-8 '>
        <label className='form-label fw-bolder text-w f-parrafo fs-6'>New Password</label>
        <div className="input-group">
          <input      
              type='password'                                 
              required
              name='name'
              className='form-control bg-transparent'
              id='Nombre'
              onChange={(event)=>setUpdatePassword(event.target.value)}
              style={{ width: '100%', maxWidth: '300px' ,margin:'auto'}}
              />
        </div>
        <br />

        <label htmlFor='newpassword' className='form-label text-w fs-6 fw-bolder mb-3'>
          Confirm Password
        </label>
          <input
            type='password'
            className='form-control bg-transparent'
            onChange={setPassword}
            style={{ width: '100%', maxWidth: '300px', margin: '0 auto' }}
          />
          {UpdatePassword.length > 0 && confirmpassword.length >0 ? UpdatePassword === confirmpassword ?<p className='text-success'>Your password is ok</p>:<p className='text-danger'>Your password is wrong</p>:<p className='text-danger'></p>}
        


        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
     {response.status!=='good'&& <div className='mb-10 p-8 rounded'>
          <div className='text-pink f-parrafo'>Ups! This token has already been used</div>
      </div>}
     
      <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
       {response.status==='good'&& <button type='submit' id='kt_password_reset_submit' className='btn btn-gradiente me-4'>
          <span className='indicator-label'>Submit</span>
          {loading && (
            <span className='indicator-progress'>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>}
        <Link to='/auth/login'>
          <button
            type='button'
            className='btn btn-gradiente'
            disabled={formik.isSubmitting || !formik.isValid}
          >
            Cancel
          </button>
        </Link>{' '}
      </div>
      {/* end::Form group */}
    </form>
    </>
  )
}
